import { render, staticRenderFns } from "./dateViewer.vue?vue&type=template&id=637ab664"
import script from "./dateViewer.vue?vue&type=script&lang=js"
export * from "./dateViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports